import { render } from "./view_document.vue?vue&type=template&id=2d2f6fc3"
import script from "./view_document.vue?vue&type=script&lang=js"
export * from "./view_document.vue?vue&type=script&lang=js"

import "./view_document.vue?vue&type=style&index=0&id=2d2f6fc3&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__